import { render, staticRenderFns } from "./MypageDiscount.vue?vue&type=template&id=583c34f4&"
import script from "./MypageDiscount.vue?vue&type=script&lang=js&"
export * from "./MypageDiscount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports